import OkC from "shared/util/OkcApi";
import {
	OKEVENT,
	triggerOkEvent,
} from "shared/util/OkEventHelpers";

const MarkMessageAsRead = (userid, msgid) => {
	OkC.post(`/messages/conversations/${userid}/read`, {
		api: 1,
		data: {
			msgid,
		},
		success: (res) => {
			if (res.success) {
				// Trigger a custom event
				triggerOkEvent(OKEVENT.ReadMessage, {
					msgid,
					userid,
				});
			}
		},
	});
};

export default MarkMessageAsRead;



// WEBPACK FOOTER //
// ./src/shared/util/MarkMessageAsRead.js